import React from 'react'
import Chart from 'react-apexcharts'
import { merge } from 'lodash'
import { defaultTypography, ptBr } from './types/index'
import { ChartColumnOptions, ChartColumnSeries, ChartColumnThemes, themes } from './types/ChartColumn'
import { formatNumber } from '../../utils/Helpers'

type Props = {
  options: ChartColumnOptions
  series: ChartColumnSeries[],
  theme?: ChartColumnThemes,
  height?: number
}

const ChartColumn = ({ options, series, theme = ChartColumnThemes.default, height = 740 }: Props): JSX.Element => {
  const defaultOptions = {
    colors: themes[theme].seriesColors,
    chart: {
      toolbar: {
        show: false
      },
      locales: [ptBr],
      defaultLocale: 'pt-br',
      ...defaultTypography
    },
    tooltip: {
      style: {
        ...defaultTypography
      }
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        horizontal: false,
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      offsetY: -20,
      formatter: (val: number) => {
        return formatNumber(val, 0)
      },
      enabled: true,
      style: {
        // colors: themes[theme].labelsColors,
        colors: ['#304758'],
        ...defaultTypography
      }
    },
    xaxis: {
      labels: {
        datetimeUTC: false,
        style: {
          colors: ['#4B4B4B'],
          ...defaultTypography
        }
      }
    },
    noData: {
      text: 'No data found :(',
      style: {
        fontSize: '12pt',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        color: '#4B4B4B',
        fontWeight: 400
      }
    }
  }
  return (
    <Chart options={merge(defaultOptions, options)} series={series} type="bar" height={height} />
  )
}

export default ChartColumn
